const deviceEventSettings = window.filterEnvironmentDeviceSettings(
  require('cloud-utils/config/events/default.json').deviceEventSettings
)
const { jobStatusType } = require('../../js/constants')
const {
  RequestRetryBackOffHelper
} = require('../../js/request-retry-backoff-helper')
angular
  .module('surfsightApp.controllers')

  .controller('edgegeofenceReportsController', [
    '$scope',
    '$rootScope',
    '$log',
    '$state',
    '$timeout',
    '$interval',
    '$location',
    '$http',
    '$filter',
    '$localStorage',
    '$mdDialog',
    '$mdMedia',
    '$mdSidenav',
    '$mdToast',
    '$mdColors',
    'edgeFactory',
    'edgeFactoryV2',
    'edgeGroupFactory',
    'leafletData',
    'nominatimLookUp',
    '$stateParams',
    'NgTableParams',
    '$q',
    function (
      $scope,
      $rootScope,
      $log,
      $state,
      $timeout,
      $interval,
      $location,
      $http,
      $filter,
      $localStorage,
      $mdDialog,
      $mdMedia,
      $mdSidenav,
      $mdToast,
      $mdColors,
      edgeFactory,
      edgeFactoryV2,
      edgeGroupFactory,
      leafletData,
      nominatimLookUp,
      $stateParams,
      NgTableParams,
      $q
    ) {
      const $translate = $filter('translate')
      const pageLimit = window.deviceReportPaginationLimit
      const groupId = parseInt($stateParams.edge_group_id)
      const deviceId = parseInt($stateParams.edge_id)
      let lastRequestQueryParams
      $scope.edge_name = ''
      const stateName = $state.current.name
      let timeFormat = 2
      if ($localStorage.timeFormat) {
        timeFormat = $localStorage.timeFormat
      }
      const initTable = () => {
        $scope.ngGeofenceReportTable = {
          columns: {
            dashcamName: {
              title: $translate('dashcamName')
            },
            date: {
              title: $translate('date')
            },
            geofenceName: {
              title: $translate('geofenceName')
            },
            direction: {
              title: $translate('direction')
            }
          },
          ngTableParams: new NgTableParams(
            {
              noPager: true,
              page: 1, // show first page
              count: pageLimit // count per page
            },
            {
              counts: [],
              filterDelay: 300,
              getData: params => {
                return new Promise((resolve, reject) => {
                  ;(async () => {
                    if ($scope.geofenceReportState) {
                      $scope.geofenceReportState.page = params._params.page
                      $scope.geofenceReportState.limit = params._params.count
                    }
                    const {
                      tableRows,
                      totalRecords
                    } = await getEdgeReportsData()
                    params.total(totalRecords)
                    resolve(tableRows)
                  })()
                })
              }
            }
          )
        }
        $scope.reportName =
          (
            `${$scope.edge_name} ` +
            `${$translate('geofenceReport')} ` +
            `(${$rootScope.reportDateRangeFilter.name_formate2}` +
            `${
              $rootScope.reportDateRangeFilter.current_year
                ? ' ' + $rootScope.reportDateRangeFilter.current_year
                : ''
            })`
          )
            .replace(/ {2}- /g, '-')
            .replace(/ {2}/g, ' ')
            .replace(/ /g, '-') + '.csv'
      }
      $scope.showMessageToast = function (message) {
        var toast = $mdToast
          .simple()
          .textContent(message)
          .action($translate('ok'))
          .position('bottom')
          .hideDelay(5000)
          .actionKey('F1')
          .parent('#device-ui-settings-container')

        $mdToast
          .show(toast)
          .then(function (response) {})
          .catch(() => {})
      }
      const initReport = async () => {
        await initEdgeStatus()
        $timeout(() => {
          initTable()
        })
      }

      const initEdgeStatus = async () => {
        if ($scope.edge) {
          const statuses = await edgeFactory.getDeviceStatuses([
            $scope.edge.uri
          ])
          if (statuses.length) {
            $scope.edge.standby = statuses[0].standby
            $scope.edge.status = statuses[0].status
          }
        }
      }
      $scope.showSearchOption = () => !deviceId
      $scope.geofenceReportState = {
        searchText: '',
        page: 1,
        limit: pageLimit,
        totalCount: 0,
        dashcam: []
      }
      if (
        [
          'home.common.reports.edge',
          'home.common.reports.edgereportDashboard'
        ].includes(stateName)
      ) {
        let edge = edgeFactory.list.find(e => e.id === deviceId)
        if (edge) {
          $scope.edge = edge
          $scope.edge_name = $scope.edge.name
          initReport()
        } else {
          const requestId = window.makeId(5)
          $scope.$emit('LOAD_DEVICE_DETAILS_REQUEST', {
            id: deviceId,
            requestId
          })
          $scope.$on('LOAD_DEVICE_DETAILS_SUCCESS', (e, data) => {
            if (data.id === deviceId && data.requestId === requestId) {
              edge = edgeFactory.list.find(e => e.id === deviceId)
              $scope.edge = edge
              $scope.edge_name = $scope.edge.name
              initReport()
            }
          })
        }
      } else if (
        [
          'home.common.reports.edgegroup',
          'home.common.reports.edgegroupreportDashboard'
        ].includes(stateName)
      ) {
        if (groupId === -1) {
          $scope.edge_name = 'Devices'
          initReport()
        } else {
          let group = edgeGroupFactory.list.find(e => e.id === groupId)
          if (group) {
            $scope.edgeGroupDetails = group
            $scope.edge_name = group.name
            initReport()
          } else {
            const requestId = window.makeId(5)
            $scope.$emit('LOAD_GROUP_DETAILS_REQUEST', {
              id: groupId,
              requestId
            })
            $scope.$on('LOAD_GROUP_DETAILS_SUCCESS', (e, data) => {
              if (data.id === groupId && data.requestId === requestId) {
                group = edgeGroupFactory.list.find(e => e.id === groupId)
                $scope.edgeGroupDetails = group
                $scope.edge_name = $scope.edgeGroupDetails.name
                initReport()
              }
            })
          }
        }
      }
      // mobile screens
      if (
        [
          'home.common.reports.edgegroupreportDashboard',
          'home.common.reports.edgereportDashboard'
        ].includes(stateName)
      ) {
        if (!$rootScope.reportDateRangeFilter) {
          // page does not have search filter information. Redirect
          if (groupId) {
            $state.go('home.common.reports.edgegroup', {
              edge_group_id: groupId
            })
          } else {
            $state.go('home.common.reports.edge', { edge_id: deviceId })
          }
        }
      }

      let searchTextTimer
      $scope.trackSearchText = () => {
        if (deviceId) return
        searchTextTimer && $timeout.cancel(searchTextTimer)
        searchTextTimer = $timeout(() => {
          $scope.geofenceReportState = {
            searchText: $scope.geofenceReportState.searchText,
            page: 1,
            limit: pageLimit,
            totalCount: 0,
            dashcam: []
          }
          $scope.ngGeofenceReportTable.ngTableParams
            .parameters({ page: 1 })
            .reload()
        }, 1500)
      }
      $scope.geofenceTableState = {
        loading: false
      }
      $scope.$on('eventSearchDataResult', (e, data) => {
        $scope.ngGeofenceReportTable.ngTableParams
          .parameters({ page: 1 })
          .reload()
      })
      const getEdgeReportsData = async () => {
        const startTime = $rootScope.reportDateRangeFilter.date.start / 1000
        const endTime = $rootScope.reportDateRangeFilter.date.end / 1000
        const { page, limit, searchText } = $scope.geofenceReportState
        const queryParams = new URLSearchParams()
        queryParams.append('startTime', startTime)
        queryParams.append('endTime', endTime)
        queryParams.append('searchText', searchText)
        queryParams.append('limit', limit)
        queryParams.append('page', page)
        lastRequestQueryParams = `${queryParams.toString()}&organizationId=${
          $rootScope.currentUserOrganization.id
        }&groupId=${groupId}`
        let url
        if (deviceId && $scope.edge) {
          url = `${EDGE_BASEURL}/device/${
            $scope.edge.uri
          }/geofence-report?${queryParams.toString()}`
        } else {
          url = `${EDGE_BASEURL}/organization/${
            $rootScope.currentUserOrganization.id
          }/group/${groupId}/geofence-report?${queryParams.toString()}`
        }
        const requestJson = {
          method: 'GET',
          url
        }
        const groupGeofenceReportResponse = await $http(requestJson)
        const {
          devicesGeofenceReport,
          totalCount
        } = groupGeofenceReportResponse.data
        const devicesGeofenceReportParsed = devicesGeofenceReport.map(
          deviceGeofenceReport => ({
            id: deviceGeofenceReport.deviceId,
            name: deviceGeofenceReport.name,
            lat: deviceGeofenceReport.lat,
            lon: deviceGeofenceReport.lon,
            geofence_name: deviceGeofenceReport.geofence_name,
            geofence_path: deviceGeofenceReport.geofence_path,
            time_string: new Date(deviceGeofenceReport.time * 1000).toString(
              timeFormat === 1 ? 'dd/MM/yyyy HH:mm' : 'dd/MM/yyyy hh:mm tt'
            ),
            eventData: deviceGeofenceReport
          })
        )
        return {
          tableRows: devicesGeofenceReportParsed,
          totalRecords: totalCount
        }
      }
      $scope.resetCurrentReportDownload = () => {
        $scope.downloadStatus = {
          downloadRequestId: '',
          downloadRequestStatus: jobStatusType.INITIAL,
          downloadUrl: ''
        }
      }
      $scope.resetCurrentReportDownload()
      const retryCurrentReportDownload = async (
        signal = new AbortController()
      ) => {
        const requestTimeout = $q.defer()
        signal.addEventListener('abort', () => {
          requestTimeout.resolve()
        })
        $scope.downloadStatus.downloadRequestId = ''
        $scope.downloadStatus.downloadRequestStatus = jobStatusType.IN_QUEUE
        const requestRetryBackOffIterator = new RequestRetryBackOffHelper(
          50,
          5,
          true,
          30
        ).getIterator()
        for await (const { attempts } of requestRetryBackOffIterator) {
          try {
            if (signal.aborted) break
            const queryParams = new URLSearchParams(
              attempts > 1
                ? {
                    downloadRequestId: $scope.downloadStatus.downloadRequestId,
                    organizationId: $rootScope.currentUserOrganization.id,
                    groupId: groupId
                  }
                : lastRequestQueryParams
            )
            ;['page', 'limit'].forEach(param => {
              queryParams.delete(param)
            })
            const requestJson = {
              method: 'GET',
              url:
                EDGE_BASEURL +
                '/geofence-report-download?' +
                queryParams.toString(),
              timeout: requestTimeout
            }
            const response = await $http(requestJson)
            if (response.data) {
              const downloadRequestStatus = response.data.downloadStatus
              if (attempts === 1) {
                $scope.downloadStatus.downloadRequestId =
                  response.data.downloadRequestId
              }
              if (downloadRequestStatus) {
                $scope.downloadStatus.downloadRequestStatus = downloadRequestStatus
                if (
                  downloadRequestStatus === jobStatusType.COMPLETED ||
                  signal.aborted
                ) {
                  $scope.downloadStatus.downloadUrl = response.data.url
                  triggerDownload($scope.downloadStatus.downloadUrl)
                  break
                }
                if (downloadRequestStatus === jobStatusType.FAILED) {
                  throw new Error(response.data.status.error)
                }
              }
            }
          } catch (ex) {
            $scope.downloadStatus.downloadRequestStatus = jobStatusType.FAILED
            $scope.showMessageToast(ex.data.status.error)
            console.error(ex)
            break
          }
          $scope.$apply()
        }
        $scope.$apply()
      }
      function triggerDownload (url) {
        const a = document.createElement('a')
        a.href = url
        a.download = ''
        a.style.display = 'none'
        document.body.appendChild(a)

        a.click()
        document.body.removeChild(a)
      }
      let previousDownloadRequestAbortController = new AbortController()
      $scope.downloadCurrentReport = () => {
        if (Number.isInteger(groupId)) {
          if (
            previousDownloadRequestAbortController &&
            !previousDownloadRequestAbortController.signal.aborted
          ) {
            previousDownloadRequestAbortController.abort()
          }
          previousDownloadRequestAbortController = new AbortController()
          retryCurrentReportDownload(
            previousDownloadRequestAbortController.signal
          )
        }
      }
      const showEventsModal = async (edge_id, edge_event) => {
        try {
          const edge = edgeFactory.list.find(e => e.id === edge_id)
          // invoking this to get isBlurringEnabled flag to show conceal icon
          const deviceData = edgeFactoryV2.findItemByImei(edge.uri)
          let device
          if (!deviceData.item) {
            device = await edgeFactoryV2.getSingleDevice(
              edge.organizationId,
              edge.uri
            )
          } else {
            device = deviceData.item
          }
          edge.isBlurringEnabled = device.isBlurringEnabled || false
          $mdDialog.show({
            locals: {
              dataFromCaller: {
                edge: edge,
                edge_event: edge_event
              }
            },
            controller: 'EdgeEventVideosController',
            templateUrl:
              './templates/edge.event.videos.view.html?t=' + window.webpackHash,
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            fullscreen: true // Only for -xs, -sm breakpoints.
          })
        } catch (error) {
          console.error('showEventsModal', error)
        }
      }
      const [geoFenceEventSetting] = deviceEventSettings.filter(
        eventSetting => eventSetting.name === 'GeoFence'
      )
      $scope.geofenceDatatableRowClicked = eventData => {
        showEventsModal(eventData.deviceId, {
          id: eventData.id,
          msg_type: 'GeoFence',
          lat: eventData.lat,
          lon: eventData.lon,
          speed: eventData.speed,
          time: eventData.time * 1000, //TODO: Remove it when new events start use
          edge_setting: geoFenceEventSetting,
          time_string_formate: new Date(eventData.time * 1000).toString(
            'h:mm:ss tt MMM dd yyyy'
          )
        })
      }
      $scope.showReportDateFilter = e => {
        $scope.$emit('SHOW_REPORT_DATE_FILTER_EMIT', { event: e })
      }
      $scope.exportReport = () => {
        if (Number.isInteger(groupId)) {
          return
        }
        $scope.ngGeofenceReportTable.ngTableParams.settings().$loading = true
        const headers = {
          dashcamName: $translate('dashcamName'),
          date: $translate('date'),
          geofenceName: $translate('geofenceName'),
          direction: $translate('direction')
        }
        const report = $scope.ngGeofenceReportTable.ngTableParams.data.map(
          tableRow => {
            return {
              [headers.dashcamName]: tableRow.name || $scope.edge_name,
              [headers.date]: tableRow.time_string,
              [headers.geofenceName]: tableRow.geofence_name,
              [headers.direction]: tableRow.geofence_path
            }
          }
        )
        $scope.ngGeofenceReportTable.ngTableParams.settings().$loading = false
        return report
      }
    }
  ])
